import { Component, OnInit } from '@angular/core';
import { AlSession, AlStopwatch, AlLocation, AlEntitlementCollection } from '@al/core';
import { AlNavigationService } from '@al/ng-navigation-components';

@Component({
    selector: 'app-home',
    templateUrl: './home-route.component.html',
    styleUrls: [ './home-route.component.scss' ]
})
export class HomeRouteComponent implements OnInit {

    private readonly mdrEntitlements = 'assess|detect|respond|tmpro|lmpro';

    constructor( public navigation:AlNavigationService ) {
    }

    ngOnInit() {
        AlStopwatch.once( async () => {
            await AlSession.ready();
            if ( AlSession.isActive() ) {
                const effectiveEntitlements: AlEntitlementCollection = await AlSession.getEffectiveEntitlements();
                const isAaidDashboardsEnabled: boolean = effectiveEntitlements.evaluateExpression(this.mdrEntitlements);

                if( (isAaidDashboardsEnabled)){
                    this.navigation.navigate.byLocation( AlLocation.DashboardsUI, "/#/" );
                } else {
                    this.navigation.navigate.byLocation( AlLocation.OverviewUI, "/#/" );
                }
            } else {
                this.navigation.navigate.byLocation( AlLocation.MagmaUI, "/#/login" );
            }
        }, 10 );
    }
}
